import "./IconResources.scss";
import { ReactComponent as ResourcesIcon } from "./svg/icon_resources.svg";

export const IconResources = () => {
  return (
    <span className="IconResources">
      <ResourcesIcon />
    </span>
  );
};
